export const GET_FLOOR_REQUEST = "GET_FLOOR_REQUEST";
export const GET_FLOOR_SUCCESS = "GET_FLOOR_SUCCESS";
export const GET_FLOOR_FAILURE = "GET_FLOOR_FAILURE";

export const ADD_FLOOR_REQUEST = "ADD_FLOOR_REQUEST";
export const ADD_FLOOR_SUCCESS = "ADD_FLOOR_SUCCESS";
export const ADD_FLOOR_FAILURE = "ADD_FLOOR_FAILURE";

export const EDIT_FLOOR_BYID_REQUEST = "EDIT_FLOOR_BYID_REQUEST";
export const EDIT_FLOOR_BYID_SUCCESS = "EDIT_FLOOR_BYID_SUCCESS";
export const EDIT_FLOOR_BYID_FAILURE = "EDIT_FLOOR_BYID_FAILURE";

export const DELETE_FLOOR_BYID_REQUEST = "DELETE_FLOOR_BYID_REQUEST";
export const DELETE_FLOOR_BYID_SUCCESS = "DELETE_FLOOR_BYID_SUCCESS";
export const DELETE_FLOOR_BYID_FAILURE = "DELETE_FLOOR_BYID_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST"
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS"
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE"

export const GET_FLOOR_BY_ID_REQUEST = "GET_FLOOR_BY_ID_REQUEST"
export const GET_FLOOR_BY_ID_SUCCESS = "GET_FLOOR_BY_ID_SUCCESS"
export const GET_FLOOR_BY_ID_FAILURE = "GET_FLOOR_BY_ID_FAILURE"

export const EXPORT_FLOOR_TABLE_REQUEST = "EXPORT_FLOOR_TABLE_REQUEST"
export const EXPORT_FLOOR_TABLE_SUCCESS = "EXPORT_FLOOR_TABLE_SUCCESS"
export const EXPORT_FLOOR_TABLE_FAILURE = "EXPORT_FLOOR_TABLE_FAILURE"

export const GET_ALL_FLOOR_LOG_REQUEST = "GET_ALL_FLOOR_LOG_REQUEST";
export const GET_ALL_FLOOR_LOG_SUCCESS = "GET_ALL_FLOOR_LOG_SUCCESS";
export const GET_ALL_FLOOR_LOG_FAILURE = "GET_ALL_FLOOR_LOG_FAILURE";

export const RESTORE_FLOOR_LOG_REQUEST = "RESTORE_FLOOR_LOG_REQUEST";
export const RESTORE_FLOOR_LOG_SUCCESS = "RESTORE_FLOOR_LOG_SUCCESS";
export const RESTORE_FLOOR_LOG_FAILURE = "RESTORE_FLOOR_LOG_FAILURE";

export const DELETE_FLOOR_LOG_REQUEST = "DELETE_FLOOR_LOG_REQUEST";
export const DELETE_FLOOR_LOG_SUCCESS = "DELETE_FLOOR_LOG_SUCCESS";
export const DELETE_FLOOR_LOG_FAILURE = "DELETE_FLOOR_LOG_FAILURE";

export const UPDATE_FLOOR_ENTITY_PARAMS_SUCCESS ="UPDATE_FLOOR_ENTITY_PARAMS_SUCCESS";
export const UPDATE_FLOOR_ENTITY_PARAMS_FAILURE ="UPDATE_FLOOR_ENTITY_PARAMS_FAILURE";

